import * as React from 'react';

const LinkedinIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.55 35.54" {...props}>
    <path d="M10.08 13.99h3.51v11.35h-3.51zM11.82 12.5c-1.15 0-2.08-.94-2.08-2.09s.93-2.09 2.08-2.09 2.08.94 2.08 2.09-.93 2.09-2.08 2.09ZM26.75 25.34h-3.5v-5.96c0-1.63-.62-2.55-1.91-2.55-1.41 0-2.14.95-2.14 2.55v5.96h-3.37V13.99h3.37v1.53s1.01-1.88 3.42-1.88 4.13 1.47 4.13 4.51v7.18Z" />
  </svg>
);

export default LinkedinIcon;
